import styles from './MiscListItem.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';
import { Link } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLink } from 'src/components/ContentLink/ContentLink';
import { isEntry } from 'src/utils/EntryUtil';

export interface IMiscListItem extends React.AllHTMLAttributes<HTMLLIElement> {
  entry?: ReferencedEntry<Link>;
  active?: boolean;
  button?: boolean;
  children?: never;
}

export const MiscListItem: React.FC<IMiscListItem> = ({
  active, entry, button, className, ...props
}) => !isEntry(entry) ? null : (
  <li
    className={cx(className, styles.miscListItem, {
      [styles.miscListItemButton]: button,
    })}
    {...props}
  >
    <ContentLink tabIndex={active ? undefined : -1} entry={entry} />
  </li>
);
